import { render, staticRenderFns } from "./ConsensiListComponent.vue?vue&type=template&id=4b47ce79"
import script from "./ConsensiListComponent.vue?vue&type=script&lang=js"
export * from "./ConsensiListComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsensiListComponent.vue?vue&type=style&index=0&id=4b47ce79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports